import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";



import { permite_acesso, PegarDados1, PegarDados2 } from "../../services/api";

const Alunos_unidade_hist = (props) => {

    const [data2, setData2] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    const unidades_sigla = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', 'NI', '', 'SP', 'BT', 'CG', 'CP', 'MG', 'MC', 'IG', 'FG', 'RB'];

    const fetchData = async () => {
        try {
            const response = await PegarDados2(data_inicio, data_fim);
            setData2(response.data);
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);


    console.log(data_inicio);
    console.log(data_fim);

    let data2tag = []

    if (typeof data2 !== 'undefined') {
        data2tag = data2.map((item, index) => {
            const row = [unidades[parseInt(item[0])]];
            row.push(unidades_sigla[parseInt(item[0])]);
            row.push(item[1])
            row.push(item[1].toString())
            row.push(item[2])
            row.push(item[2].toString())
            row.push(item[3])
            row.push(item[3].toString())
            row.push(item[4])
            row.push(item[4].toString())
            return row;

        });
    };


    data2tag.shift();

    data2tag.sort();

    data2tag = data2tag.map(row => row.slice(1));

    data2tag.unshift(['UNIDADE', '2027', { role: 'annotation' }, '2026', { role: 'annotation' }, '2025', { role: 'annotation' }, '2024', { role: 'annotation' }]);


    const options = {
        // title: "Alunos por ano e unidade",
        // vAxis: { title: "Alunos" },
        // hAxis: { title: "UNIDADE" },
        seriesType: "bars",

        height: 400,
        legend: "top",
        titleTextStyle: { color: 'black', fontSize: '15' },

    };


    return (

        <div className="Alunos_unidade_hist">
            <Chart
                chartType="ComboChart"
                version="current"
                width="105%"
                height="400px"
                data={data2tag}
                options={options}
            />

        </div>



    );
};

export default Alunos_unidade_hist;